<template>
    <div>
        <div v-if="imageBool" class="contactUsTodayContainer">

            <img loading=lazy src="../assets/images/footer.png">
            <div class="contactUsToday">
                <p class="contactusCopy">{{ headText }}</p>
                <p class="contactusCopy">{{ subheadText }}</p>
                <div class=" mt-3 contactus_btn">
                    <div v-if="!AITool" class="ef-btn" v-b-modal.demo-form>{{ buttonText }}</div>
                    <div v-else>
                        <button type="button" class="btn btn-outline-success hide-btn-focus ef-btn">
                            <router-link class="routerLinkText" to="/smb/sign-up">{{ buttonText }}</router-link>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div v-else class="header-div">
            <div>
                <button v-if="!AITool" class="btn btn-outline-success hide-btn-focus ef-btn" type="button"
                    v-b-modal.demo-form>
                    {{ buttonText }}
                </button>
                <div v-else>
                    <button type="button" class="btn btn-outline-success hide-btn-focus ef-btn">
                        <router-link class="routerLinkText" to="/smb/sign-up">{{ buttonText }}</router-link>
                    </button>
                </div>
            </div>
        </div>

        <b-modal v-if="includeModal" ref='demo-form' modal-class="request-modal-content" centered
            header-class="header-class" id="demo-form" :hide-footer="true">
            <template #modal-header>
                <div class="w-100">
                    <h3>REQUEST A DEMO </h3>
                </div>
                <b-icon-x class="ml-auto icon-close" @click="closeModal()"></b-icon-x>
            </template>
            <div class="row">
                <div class="col">
                    <div class="input-text-field">
                        <label class="input-text">Name *</label>
                        <b-form-input :state="validateName" type="text" class="form-control name-input" v-model="name"
                            required></b-form-input>
                        <b-form-invalid-feedback v-if="name.length > 0" :state="validateName">
                            Name cannot be empty
                        </b-form-invalid-feedback>
                    </div>

                    <div class="input-text-field">
                        <label class="input-text">Business Email *</label>
                        <b-form-input :state="validateEmail" type="text" class="form-control" v-model="businessEmail"
                            required></b-form-input>
                        <b-form-invalid-feedback v-if="businessEmail.length > 0" :state="validateEmail">
                            Input correct email
                        </b-form-invalid-feedback>
                    </div>

                    <div class="input-text-field">
                        <label class="input-text">Industry Type</label>
                        <b-form-input type="text" :state="validateIndustry" class="form-control" v-model="industryType"
                            ></b-form-input>
                        <b-form-invalid-feedback v-if="industryType.length > 0" :state="validateIndustry">
                            Industry cannot be empty
                        </b-form-invalid-feedback>
                    </div>

                    <div class="input-text-field">
                        <label class="input-text">Job Title</label>
                        <b-form-input type="text" :state="validateJob" class="form-control" v-model="jobTitle"
                        ></b-form-input>
                        <b-form-invalid-feedback v-if="jobTitle.length > 0" :state="validateJob">
                            Job cannot be empty
                        </b-form-invalid-feedback>
                    </div>
                </div>

                <div class="col">
                    <div class="input-text-field">
                        <label class="input-text">LinkedIn URL</label>
                        <b-form-input :state="validateLinkedin" type="text" class="form-control" v-model="linkedin"
                        ></b-form-input>
                        <b-form-invalid-feedback v-if="linkedin.length > 0" :state="validateLinkedin">
                            Enter a valid linkedin id
                        </b-form-invalid-feedback>
                    </div>
                    <b-form-group class="phoneInput">
                        <label class="input-text">Phone Number</label>
                        <vue-tel-input v-model="phoneNumber" :input-options="phoneInputOptions"
                            :dropdown-options="dropdownOptions">
                            <template v-slot:arrow-icon>
                                <span class="vti__dropdown-arrow">{{ open ? '▲' : '▼' }}</span>
                            </template>
                        </vue-tel-input>
                    </b-form-group>
                    <div class="input-text-field" style="padding-top: 3px !important;">
                        <label class="input-text">Company</label>
                        <b-form-input type="text" :state="validateCompany" class="form-control" v-model="company"
                        ></b-form-input>

                        <b-form-invalid-feedback v-if="company.length > 0" :state="validateCompany">
                            Company cannot be empty
                        </b-form-invalid-feedback>

                    </div>
                    <div class="input-text-field">
                        <label class="input-text">How did you hear about us?</label>
                        <input type="text" class="form-control" v-model="hearAboutUs">
                    </div>
                </div>
            </div>
            <div class="row" style="padding: 0 15px;">
                <div class="col input-text-field">
                    <label class="input-text">Comments</label>
                    <textarea class="form-control rounded-2" id="formControlTextarea1" v-model="comments" rows="3"
                        required></textarea>
                </div>
            </div>
            <div class="btn-div">
                <b-button class="btn btn-outline-success hide-btn-focus ef-btn" @click="sendEmail()">Submit</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import API from '../module_admin/api.js';
export default {
    data: function () {
        return {
            name: "",
            linkedin: "",
            businessEmail: "",
            phoneNumber: "",
            country: "",
            industryType: "",
            company: "",
            jobTitle: "",
            hearAboutUs: "",
            comments: "",
            phoneInputOptions: {
                maxlength: 10,
                placeholder: "Mobile No.",
                required: true,
                invalidMsg: 'Invalid Mobile Number',
                validCharactersOnly: true
            },
            dropdownOptions: {
                showDialCodeInList: true,
                showDialCodeInSelection: true,
                showFlags: true,
                width: '390px'
            },
            validName: true,
            validEmail: false,
            validIndustry: false,
            validJob: false,
            validLinkedin: false,
            validCompany: false,
            doValidation: false,
        };
    },

    //     validateName() {
    //         if (!this.doValidation)
    //             return undefined;
    //         return this.name != "";
    //     },
    //     validateEmail() {
    //         if (!this.doValidation)
    //             return undefined;
    //         return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.businessEmail);
    //     },
    //     validateIndustry() {
    //         if (!this.doValidation)
    //             return undefined;
    //         return this.industryType != "";
    //     },
    //     validateJob() {
    //         if (!this.doValidation)
    //             return undefined;
    //         return this.jobTitle != "";
    //     },
    //     validateLinkedin() {
    //         if (!this.doValidation)
    //             return undefined;
    //         return /^(http(s)?:\/\/)?([\w]+\.)?linkedin\.com\/(in|pub)\/[\w-]+\/?$/.test(this.linkedin);
    //     },
    //     validateCompany() {
    //         if (!this.doValidation)
    //             return undefined;
    //         return this.company != "";
    //     }

    // },
    methods: {
        closeModal() {
            this.$bvModal.hide('demo-form')
        },
        async validateEmail() {
            if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.businessEmail)) {
                return true;
            }
            this.$bvToast.toast("Invalid Email Address", {
                variant: "danger",
            }); return false;
        },
        async validateLinkedin() {
            if(!this.linkedin || this.linkedin.length === 0) return true;
            else if (/^(http(s)?:\/\/)?([\w]+\.)?linkedin\.com\/(in|pub)\/[\w-]+\/?$/.test(this.linkedin)) {
                return true;
            }
            this.$bvToast.toast("Invalid LinkedIn Id", {
                variant: "danger",
            }); return false;
        },
        validateCompany() {
            if (!this.doValidation)
                return undefined;
            return this.company != "";
        },
        validateIndustry() {
            if (!this.doValidation)
                return undefined;
            return this.industryType != "";
        },
        validateJob() {
            if (!this.doValidation)
                return undefined;
            return this.jobTitle != "";
        },
        validateName() {
            if (!this.doValidation)
                return undefined;
            if(this.name === ""){
                this.$bvToast.toast("Invalid Name", {
                    variant: "danger",
                });
            }
            return this.name != "";
        },
        resetForm(){
            this.name = ""            
            this.linkedin = ""
            this.businessEmail = ""
            this.phoneNumber = ""
            this.industryType = ""
            this.company = ""
            this.jobTitle = ""
            this.hearAboutUs = ""
            this.comment = ""
        },
        async sendEmail() {
            this.doValidation = true;
            let validLinkedin = await this.validateLinkedin();
            let validEmail = await this.validateEmail();
            let validName = await this.validateName();
            let validJobTitle = await this.validateJob();
            let validIndustry = await this.validateIndustry();
            let validCompany = await this.validateCompany();

            if (!validEmail || !validLinkedin || !validName) {
                return;
            }

            if (validEmail === true && validLinkedin === true) {
                let emailData = {
                    name: this.name,
                    linkedin: this.linkedin,
                    business_email: this.businessEmail,
                    phone_number: this.phoneNumber,
                    industryType: this.industryType,
                    company: this.company,
                    job_title: this.jobTitle,
                    hear_about_us: this.hearAboutUs,
                    comments: this.comments
                }
                try {
                    let response = await API.submitRequestForm(emailData);
                    if (response.status === 200) {
                        this.$bvToast.toast("Request submitted successfully", {
                            variant: "success",
                            solid: true,
                            toaster: 'b-toaster-top-center'
                        });
                        this.doValidation = false;
                        this.resetForm();
                        this.closeModal();
                    }
                }
                catch (error) {
                    this.$bvToast.toast("Failed to submit details", {
                        variant: "danger",
                    });
                }
            }
        }
    },

    watch: {
        name: {
            handler() {
                function validateName() {
                    return this.name != "";
                }
            }
        },
        businessEmail: {
            handler() {
                function validateEmail() {
                    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.businessEmail);
                }
            }
        },
        industryType: {
            handler() {
                function validateIndustry() {
                    return this.industryType != "";
                }
            },
        },
        jobTitle: {
            handler() {
                function validateJob() {
                    return this.jobTitle != "";
                }
            },
        },
        linkedin: {
            handler() {
                function validateLinkedin() {
                    return /^(http(s)?:\/\/)?([\w]+\.)?linkedin\.com\/(in|pub)\/[\w-]+\/?$/.test(this.linkedin);
                }
            }
        },
        company: {
            handler() {
                function validateCompany() {
                    return this.company != "";
                }
            },
        },
    },

    props: {
        buttonText: {
            type: String,
            default: "Request a Demo",
        },
        imageBool: {
            type: Boolean,
            default: true,
        },
        includeModal: {
            type: Boolean,
            default: true,
        },
        AITool: {
            type: Boolean,
            default: false,
        },
        headText: {
            type: String,
            default: "Want to know more?",
        },
        subheadText: {
            type: String,
            default: "Contact us today!",
        },
    }
};

</script>

<style lang="scss" scoped>
legend {
    all: unset;
}

::v-deep .header-class {
    background: #73bc44;
    color: white;
    font-weight: bold;
    font-size: 30px;
    text-align: center;
}

p {
    font-weight: bold;
    font-size: 40px;
    margin-bottom: 0px;
}

.routerLinkText {
    color: white;
}

.contactUsTodayContainer {
    position: relative;

    img {
        width: 100%;
        object-fit: cover !important;
        height: 100%;
        overflow: hidden;
        filter: brightness(80%);
    }
}

.contactUsToday {
    position: absolute;
    top: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
    justify-content: center;
}

.contactus_btn {
    display: flex;

    a {
        text-decoration: none;
    }
}

.contactusCopy {
    font-family: "Poppins-Bold";
    font-size: 35px;
    color: #FFFFFF;
}

.icon-close {
    cursor: pointer;
}

.btn-div {
    text-align: center;
}

.hide-btn-focus:focus {
    box-shadow: none !important;
}

.input-text {
    text-align: left;
}

.input-text-field {
    padding: 10px;
}

@media (max-width: 576px) and (orientation: portrait) {

    .contactUsTodayContainer {
        height: 50vh;
        position: relative;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
}
</style>